export default __webpack_public_path__ + "static/media/bo_7.447e9109.mp3";